import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Home, ChefHat, LogIn, Package, Settings, LogOut, Menu, X, User } from 'lucide-react';
import './Header.css';

const Header: React.FC = () => {
  const { currentUser, logout, isAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
      setIsMenuOpen(false);
    } catch (error) {
      console.error('Гарах үед алдаа гарлаа:', error);
    }
  };

  const isActiveLink = (path: string) => {
    return location.pathname === path;
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={() => setIsMenuOpen(false)}>
          <div className="logo-icon">🍔</div>
          <div className="logo-text">
            <span className="logo-main">Burger</span>
            <span className="logo-sub">AI</span>
          </div>
        </Link>
        
        <button className="mobile-menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
        
        <nav className={`nav-menu ${isMenuOpen ? 'nav-menu-open' : ''}`}>
          <Link 
            to="/" 
            className={`nav-link ${isActiveLink('/') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            <Home size={18} />
            <span>Нүүр хуудас</span>
          </Link>
          <Link 
            to="/burger-builder" 
            className={`nav-link ${isActiveLink('/burger-builder') ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(false)}
          >
            <ChefHat size={18} />
            <span>Бургер бүтээх</span>
          </Link>
          
          {currentUser ? (
            <>
              <Link 
                to="/orders" 
                className={`nav-link ${isActiveLink('/orders') ? 'active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                <Package size={18} />
                <span>Миний захиалга</span>
              </Link>
              {isAdmin && (
                <Link 
                  to="/admin" 
                  className={`nav-link admin-link ${isActiveLink('/admin') ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  <Settings size={18} />
                  <span>Удирдлага</span>
                </Link>
              )}
              <div className="user-info">
                <div className="user-avatar">
                  <User size={16} />
                </div>
                <div className="user-details">
                  <span className="user-email">{currentUser.email}</span>
                  <span className="user-role">{isAdmin ? 'Админ' : 'Хэрэглэгч'}</span>
                </div>
                <button onClick={handleLogout} className="btn btn-logout">
                  <LogOut size={16} />
                  <span>Гарах</span>
                </button>
              </div>
            </>
          ) : (
            <Link 
              to="/login" 
              className={`btn btn-primary ${isActiveLink('/login') ? 'active' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            >
              <LogIn size={18} />
              <span>Нэвтрэх</span>
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
